import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthFirebaseService } from '@shared/services/auth-firebase.service';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/redux/config-store-state.model';
import { emitAlert } from '@shared/redux/actions/actions-store-state.model';

@Component({
  selector: 'astrea-profile-security',
  templateUrl: './profile-security.component.html',
  styleUrls: ['./profile-security.component.scss']
})
export class ProfileSecurityComponent {

  public user: any;
  @Input()
    set setUser(u: any) {
      this.user = u;
    };

  public loading = false;

  constructor(
    private store: Store<AppState>,
    private authFirebaseService: AuthFirebaseService,
    private _t: TranslateService,
  ) { }

  changePass(): void {
    this.loading = true;
    this.authFirebaseService.sendEmailChangePass(this.user.email)
      .then(() => {
        this.loading = false;
        this.recoverPassOK();
      })
      .catch(err => {
        this.loading = false;
        this.recoverPassErr();
      });
  }

  recoverPassOK(): void {
    this.store.dispatch(emitAlert({
      message: this._t.instant('alert.forgot_password.ok'),
      alertType: 'success'
    }));
  }

  recoverPassErr(): void {
    this.store.dispatch(emitAlert({
      message: this._t.instant('alert.forgot_password.err'),
      alertType: 'danger'
    }));
  }

}
